module.exports = __webpack_public_path__ + "media/images/social-share-button/qq-883b6ea8c69ef9ce093c270d4c018879.svg";